import { enumFieldType, FieldTypeToLabel, kFieldOptions } from "../constants";
import { IsFieldNameReserved } from "./IsFieldNameReserved";

const CAMEL_CASE_BOUNDARY_RE = /([a-z])([A-Z])/g;
const WORD_SEP_RE = /[ _-]+/;

export function isDateFieldName(fieldName: string): boolean {
  if (typeof fieldName !== "string" || fieldName.length === 0) return false;
  const normalized = fieldName.replace(CAMEL_CASE_BOUNDARY_RE, "$1 $2");
  return normalized.split(WORD_SEP_RE).some(word => word.toLowerCase() === "date");
}

/**
 * Gets the field type enum value from explicit type or field name heuristics.
 *
 * @param fieldName - The field name (used for fallback heuristics when no explicit type)
 * @param fieldFormatType - The explicit field type string from chartConfig.fieldFormats[fieldName]?.type
 * @returns The enumFieldType value (enumFieldType.text, enumFieldType.date, etc.)
 * @throws Error if fieldName is not a non-empty string
 */
export function getFieldType(fieldName: string, fieldFormatType?: string): number {
  // If we have an explicit type and it's valid
  if (fieldFormatType && kFieldOptions.includes(fieldFormatType)) {
    return enumFieldType[fieldFormatType.toLowerCase() as keyof typeof enumFieldType];
  }

  // Fallback heuristics based on field name
  const lowerName = fieldName.toLowerCase();
  if (lowerName.includes("photo")) {
    return enumFieldType.image;
  }
  if (isDateFieldName(fieldName)) {
    return enumFieldType.date;
  }
  if (IsFieldNameReserved(fieldName.replaceAll(" ", ""))) {
    return enumFieldType.number;
  }

  return enumFieldType.text;
}

/**
 * Gets the field type as a display string.
 *
 * @param fieldName - The field name (used for fallback heuristics when no explicit type)
 * @param fieldFormatType - The explicit field type string from chartConfig.fieldFormats[fieldName]?.type
 * @returns The field type display string ("Text", "Date", "Number", "Image", etc.)
 */
export function getFieldTypeString(fieldName: string, fieldFormatType?: string): string {
  return FieldTypeToLabel[getFieldType(fieldName, fieldFormatType)];
}
